export default __webpack_public_path__ + "static/media/3k-achieved.aa97662f.svg";